module.exports = __webpack_public_path__ + "dimer/static/img/discoveryPageBG2.c337d0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/discoveryPageBG2.jpg
// module id = CLmA
// module chunks = 0